import { styled } from '@mui/material';

export const sxStyles = {
  title: {
    marginBottom: '2rem',
  },
};

export const StyledSectionInner = styled('div')(({ theme }) => ({
  margin: '1rem 0',

  [theme.breakpoints.up('sm')]: {
    margin: '2rem 0 2.75rem',
  },
}));

export const StyledCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));
